import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireBusinessDashboard } from "@/lib/auth-guard";

export const Route = createFileRoute("/dashboard/$businessSlug")({
  beforeLoad: requireBusinessDashboard,
  component: Outlet,
});
